<template>
  <div>
    <v-col>
      <sds-text-view
        class="text-right mr-8"
        label="Ordenar por:"
        :label-bold="true"
      />
      <v-menu rounded offset-y>
        <template #activator="{ attrs, on }">
          <v-btn plain v-bind="attrs" small class="pa-0" v-on="on">
            {{ value?.label || value?.text || '' }}
            <v-icon class="ml-2">
              {{ mdiMenuDown }}
            </v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            link
            dense
            ripple
            @click="setItem(item)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ item?.label || item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </div>
</template>

<script lang="ts" setup>
import { mdiMenuDown } from '@mdi/js';

interface IProps {
  value?: IItem;
  items?: IItem[];
}

interface IItem {
  text?: string;
  label?: string;
  value: string;
}

interface IEmits {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'Value', value: any | undefined): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'change', e: any): void;
}

const props = defineProps<IProps>();

const emit = defineEmits<IEmits>();

const setItem = (item: IItem) => {
  const useProps = props;
  if (useProps) return emit('change', item);
};
</script>
